import styled from 'styled-components';

export const LabelSection = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
  border-top: 0.5px solid rgba(23, 57, 77, 0.2);
  padding: 20px 0;
`;
